$(document).ready(function () {

    $(document).on('click', '#factura', function (e) {
        loading_small_small('div_billing');
        if ($("input[name='factura']:checked").val() === 'Y') {
            $('#div_billing').show();
            update_billing();
            //validatePaypal();
        } else {
            setTimeout(function () {
                document.getElementById('div_billing').innerHTML = '';
            }, 200);
            //$('#div_billing').hide();
        }
    });

    function update_billing() {
        $.ajax({
            url: window.location.origin + '/change/user/billing/',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_billing').innerHTML = response;
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }

    window.addBilling = function () {
        $.ajax({
            url: window.location.origin + '/add-billing',
            type: 'GET',
        })
            .done(function (view) {
                document.getElementById('div_modal').innerHTML = view;
                $("#modal-add-billing").modal('show')
                $('.chosen-select').chosen({width: '100%'});
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }

    window.editBilling = function () {
        $.ajax({
            url: window.location.origin + '/get-billings',
            type: 'GET',
        })
            .done(function (view) {
                document.getElementById('div_modal').innerHTML = view;
                $("#billing_show").modal('show')
                //$('.chosen-select').chosen({width: '100%'});
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }

    $(document).on('click', '#open-modal-add-billing_modal', function (e) {
        $("#billing_show").modal('hide');
        setTimeout(function () {
            addBilling();
        }, 300)
    });

    $(document).on('click', '.show-edit-billing', function (e) {
        e.preventDefault();
        let data = new FormData();
        let slug = $(this).data('data');
        $("#billing_show").modal("hide");
        data.append('value', slug)
        editBilling(data);


        /*
                let data = new FormData();
                let slug = $(this).data('data');
                $("#billing_edit").modal("hide");
                /!*$("#loadingSolProveedora").addClass("loading-sol-proveedora");*!/
                $("#loadingSolProveedora").addClass("loading-sol-proveedora");
                data.append('value', slug)
                //$(".modal_edit_billing").modal("show");
                editBillings(data);
        */

    })

    function editBilling(value) {
        $.ajax({
            url: window.location.origin + '/edit-billing',
            method: 'POST',
            data: value,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        })
            .done(function (view) {
                setTimeout(function () {
                    document.getElementById('div_modal').innerHTML = view;
                    $("#modal_edit_billing").modal('show')
                    $('.chosen-select').chosen({width: '100%'});
                }, 300);
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }

    $(document).on('change', '#regimen_fiscal', function () {
        loading_small_small('div_uso_cfdi_add');
        let regimen_fiscal = $('#regimen_fiscal').val()
        sendData(regimen_fiscal)
    });

    function sendData(regimen_fiscal) {
        $.ajax({
            url: window.location.origin + '/get/uso/cfdi/' + regimen_fiscal,
            type: 'GET',
        })
            .done(function (view) {
                document.getElementById('div_uso_cfdi_add').innerHTML = view;
                $('.chosen-select').chosen({width: '100%'});
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }

    $(document).on('keyup', '#zipcode11_billing', function () {
        let data = new FormData();
        $('.select-colonia-billing').empty();
        data.append('zipCode', $("#zipcode11_billing").val());
        getInfoByZipCodeBilling(data)
    })

    function getInfoByZipCodeBilling(datos) {
        let asentamiento = ""
        $.ajax({
            url: "/get-info-by-zip-code",
            type: "POST",
            data: datos,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    $.each(data.zipCodes, function (i, value) {
                        asentamiento = value.d_tipo_asenta + " " + value.colonia;
                        $('.select-colonia-billing').append($('<option>', {
                            value: value.id,
                            text: asentamiento
                        }));
                        $('.select-colonia-billing').trigger("chosen:updated");
                        $(".item-billing-estado").val(value.estado)
                        $(".item-billing-ciudad").val(value.ciudad)
                        $(".item-billing-municipio").val(value.municipio)
                    })
                } else {
                    $("#list-zipCode1").hide();
                    $("#item-codigo-postal-error").html(data.msg).css('color', 'red')
                }
            },
            error: function (errors) {
                var indices = errors.responseJSON;
                $.each(indices, function (index, value) {

                });
            }
        });
    }

    $(document).on('submit', "#form-agregar-facturacion", function (e) {
        e.preventDefault();

        let rf = $("#regimen_fiscal").val();
        let uso_cfdi = $("#cfdi4_id").val();

        if (rf == 0) {
            swal.fire('Advertencia', 'Seleccione un Régimen Fiscal', 'error');
            return true;
        }

        if (uso_cfdi == 0) {
            swal.fire('Advertencia', 'Seleccione un uso del CFDI', 'error');
            return true;
        }

        if (rf != 0 && uso_cfdi != 0) {

            let data = $(this).serialize();

            $.ajax({
                method: "POST",
                url: '/add-billing',
                data: data,
                success: function (data) {
                    if (data.status == "success") {
                        $("#modal-add-billing").modal('hide');
                        swal.fire({
                            title: data.title,
                            text: data.message,
                            icon: 'success',
                        }).then((result) => {
                            loading_small_small('div_billing');
                            setTimeout(function () {

                                let url = window.location.href;
                                url = url.replace('#', '');

                                //esto es por que se reutiliza el mismo codigo en el form de Mis Datos
                                if (url === window.location.origin + '/mis-datos') {
                                    window.location.reload();
                                }

                                document.getElementById('div_billing').innerHTML = data.view;
                            }, 700);
                        });
                    } else {
                        alertSuccess('Ocurrió un problema')
                        setTimeout(function () {
                            location.reload();
                        }, 700);
                    }
                },
                error: function (errors, xhr, status,) {
                    $("#loadingSolProveedora").removeClass("loading-sol-proveedora")
                    var indices = errors.responseJSON.errors;
                    $.each(indices, function (index, value) {
                        $("#item-" + index + "-error").html(value).css('color', 'red');
                    });

                    if (indices['cfdi4_id'] === 'error_cfdi') {
                        swal.fire('Advertencia', 'Seleccione un uso del CFDI', 'error');
                    }
                }
            });
        }
    })

    $(document).on('submit', "#form-editar-facturacion", function (e) {
        e.preventDefault();
        let rf = $("#regimen_fiscal").val();
        let uso_cfdi = $("#cfdi4_id").val();

        if (rf == 0) {
            swal.fire('Advertencia', 'Seleccione un Régimen Fiscal', 'error');
            return true;
        }

        if (uso_cfdi == 0) {
            swal.fire('Advertencia', 'Seleccione un uso del CFDI', 'error');
            return true;
        }
        if (rf != 0 && uso_cfdi != 0) {

            const data = $(this).serialize();

            $.ajax({
                method: "POST",
                url: window.location.origin + '/update-billings-cart',
                data: data,
                success: function (data) {
                    $("#div_billing").show();
                    if (data.status == "success") {
                        $("#modal_edit_billing").modal('hide');
                        swal.fire({
                            title: data.title,
                            text: data.message,
                            icon: 'success',
                        }).then((result) => {
                            loading_small_small('div_billing');
                            setTimeout(function () {

                                let url = window.location.href;
                                url = url.replace('#', '');

                                //esto es por que se reutiliza el mismo codigo en el form de Mis Datos
                                if (url === window.location.origin + '/mis-datos') {
                                    window.location.reload();
                                }

                                document.getElementById('div_billing').innerHTML = data.view;
                            }, 700);
                        });
                    } else {
                        alertSuccess('Ocurrió un problema')
                        console.log(data);
                        setTimeout(function () {
                            //location.reload();
                        }, 700);
                    }
                },
                error: function (errors, xhr, status,) {
                    $("#loadingSolProveedora").removeClass("loading-sol-proveedora")
                    var indices = errors.responseJSON.errors;
                    $.each(indices, function (index, value) {
                        $("#item-" + index + "-error").html(value).css('color', 'red');
                    });

                    if (indices['cfdi4_id'] == 'error_cfdi') {
                        swal.fire('Advertencia', 'Seleccione un uso del CFDI', 'error');
                    }
                }
            });
        }
    })


    $(document).on('change', '.item-billing-direccion_predeterminada', function () {
        if (this.checked) {
            let data = new FormData();
            data.append('id', $("#id").val());
            sendDataBilling(data);
        }
    })

    function sendDataBilling(data) {
        $.ajax({
            method: "POST",
            url: '/select-billing',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.status === "fail") {
                    //no se hace nada *Checar comentarrios en el controlador*
                } else if (data.status === "success") {
                    $(".modal_edit_billing").modal('hide');
                    swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: 'success',
                    }).then((result) => {
                        loading_small_small('div_billing');
                        setTimeout(function () {
                            document.getElementById('div_billing').innerHTML = data.view;
                        }, 700);
                    });
                } else {
                    alertSuccess('Ocurrió un problema')
                    setTimeout(function () {
                        location.reload();
                    }, 700);
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }


    $(document).on('click', '.delete-attribute-link-billing', function (e) {
        let reference = $(this).data('reference');
        let data = new FormData();
        data.append('id', reference);
        swal.fire({
            title: '¿Estas seguro?',
            text: "La dirección seleccionada sera eliminada",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteItemBilling(data, reference);
            }
        })
    });

    function deleteItemBilling(data, position) {
        $.ajax({
            method: "POST",
            url: '/delete-billings',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    swal.fire({
                        title: 'Eliminado',
                        text: data.msg,
                        icon: 'success',
                    }).then((result) => {
                        setTimeout(function () {

                            let url = window.location.href;
                            url = url.replace('#', '');

                            //esto es por que se reutiliza el mismo codigo en el form de Mis Datos
                            if (url === window.location.origin + '/mis-datos') {
                                window.location.reload();
                            }

                            $('#billing_show').find(".direcciones_contenedor-" + position).remove();
                        }, 300)
                    })
                } else {
                    alertError(data.msg)
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }


})
